import BaseApiAction from '@Actions/base-api-action';

export default class GetTeamSubscriptions extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'subscriptions-getTeamSubscriptions',
      payload: { ...this._payload },
    });
  }
}
